<ul class="icon-list" [class.alt]="icons.length < 5">
	<li *ngFor="let icon of icons" [class.capitalize]="icon.capitalize">
		<i class="text-hl" [ngClass]="icon.class_name"></i>
		<span>{{ icon.value }}</span>
	</li>
</ul>
